import React from 'react';
import PropTypes from 'prop-types';
import { UiPictureBox } from './PictureBox.style';
import organizationDefaultImage from 'assets/images/classBaseImg.png';
/**
 * 相簿,相片圖片組件
 */

export const PictureBox = ({ path = organizationDefaultImage, id = '' }) => {
  return (
    <UiPictureBox path={path === '' ? organizationDefaultImage : path} />
  );
};

PictureBox.propTypes = {
  path: PropTypes.string,
  id: PropTypes.string,
};


